import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ChartTooltip from 'components/molecules/Tooltips/ChartTooltip/ChartTooltip';

const StyledTasksTooltip = styled(ChartTooltip)`
  .TasksTooltip {
    &-content {
      padding: ${props => props.theme.spacing(0.5)};
      min-width: ${props => props.theme.layout(200)};

      .Badge {
        .MuiBadge-badge {
          font-size: ${props => props.theme.fontSize(11)};
          height: ${props => props.theme.layout(16)};
        }
      }

      .Span {
        font-size: ${props => props.theme.fontSize(13)};
        margin-left: 0;
        margin-right: ${props => props.theme.layout('1sp')};
      }
      
      .Divider {
        margin-top: ${props => props.theme.spacing(0.75)};
        margin-bottom: ${props => props.theme.spacing(0.75)};
      }

      .title {
        display: flex;
        align-items: center;
        padding: ${props => props.theme.spacing(0.5)} 0;
        ${props => props.theme.font2Css('caption')};
        &:not(:has(.Icon, .Avatar)) {
          font-weight: 500;
        }
        
        .Icon {
          font-size: inherit;
          height: ${props => props.theme.layout(12)};
          width: ${props => props.theme.layout(12)};
          margin-right: ${props => props.theme.layout('0.5sp')};

          &.Avatar {
            font-size: ${props => props.theme.fontSize(13)};
            height: ${props => props.theme.layout(16)};
            width: ${props => props.theme.layout(16)};
          }
        }
        
        .Span {
          flex-grow: 1;
        }
      }
      
      .Divider {
        margin-left: ${props => props.theme.layout('-1sp')};
        margin-right: ${props => props.theme.layout('-1sp')};
      }
    }
  }

  &.TasksTooltip-extended, &.TasksTooltip-types {
    .TasksTooltip-content {
      .extended {
        display: flex;
        flex-direction: column;

        .type {
          display: flex;
          align-items: center;

          .Span {
            flex-grow: 1;
            font-weight: 400;
          }

          .Badge {
            .MuiBadge-badge {
              color: ${props => props.theme.property('palette.text.primary')};
            }
          }
        }
      }
    }
  }
  
  &.TasksTooltip-extended {
    .TasksTooltip-content {
      .title {
        ${props => props.theme.font2Css('subtitle2')};

        .Span {
          font: inherit;
        }
        
        .Icon {
          font-size: inherit;
          height: ${props => props.theme.layout(16)};
          width: ${props => props.theme.layout(16)};

          &.Avatar {
            font-size: ${props => props.theme.fontSize(13)};
            height: ${props => props.theme.layout(16)};
            width: ${props => props.theme.layout(16)};
          }
        }
      }

      .extended {
        font-size: ${props => props.theme.fontSize(13)};
        padding: ${props => props.theme.layout('0.5sp')} 0;
        gap: ${props => props.theme.layout('1sp')};

        .Avatar {
          margin-right: ${props => props.theme.layout('0.5sp')};
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledTasksTooltip.propTypes = {
  theme: PropTypes.object
};

export default StyledTasksTooltip;
